import { Link } from "react-router-dom"
import { Text } from "@/components/Primitives/Text"
import { useConfig } from "@/hooks/useConfig"
import { Card } from "@/components/Primitives"

export function UnsubscribePage() {
  const { t } = useConfig()

  return (
    <div className="flex items-center justify-center">
      <Card className="flex flex-col items-center justify-center min-h-[85vh] md:min-h-[80vh] md:w-fit md:px-10">
        <img
          src="/images/success.png"
          alt=""
          className="w-40 h-40 mb-2"
          draggable={false}
        />
        <Text variant="h2" bold className="text-center mb-6 text-purple-200">
          {t("config_unsubscribe_title")}
        </Text>
        <Text variant="paragraph" className="text-center mb-6 max-w-md">
          {t("config_unsubscribe_message")}{" "}
          <Link
            className="text-purple-500 hover:text-purple-700 font-semibold"
            to="/profile#notifications"
          >
            {t("config_unsubscribe_link_text")}
          </Link>
          .
        </Text>
      </Card>
    </div>
  )
}
